module.exports = __webpack_public_path__ + "img/i-7.20e22abe.svg";